export default "/_nuxt/41326b39dee8c2b4fdbd4a4e61a57be5.svg";